import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import RemoteSideNavigationErrorRetry from './RemoteSideNavigationErrorRetry';
import i18n from '../../utils/i18n';

const RemoteSideNavigationCollapsedError = () => (
  <Tooltip
    content={i18n.t('TOOL_NAVIGATION_ERROR')}
    placement={Tooltip.PLACEMENTS.RIGHT}
  >
    <Flex
      flexDirection="column"
      alignItems="center"
      maxWidth="48px"
      p="0 4px"
      mt="12px"
    >
      <AlertWarningIcon
        size={24}
        color={theme.colors.yellowOrange500}
        style={{ marginBottom: 9 }}
      />
      <RemoteSideNavigationErrorRetry />
    </Flex>
  </Tooltip>
);

export default RemoteSideNavigationCollapsedError;
